import Table from 'components/Table'
import TabList from 'share-ui/components/Tabs/TabList/TabList'
import Tab from 'share-ui/components/Tabs/Tab/Tab'
import TabsContext from 'share-ui/components/Tabs/TabsContext/TabsContext'
import TabPanels from 'share-ui/components/Tabs/TabPanels/TabPanels'
import TabPanel from 'share-ui/components/Tabs/TabPanel/TabPanel'
import {
    StyledChatWrapper,
    StyledContainer,
    StyledHorizontalDivider,
    StyledMainWrapper,
} from 'routes/ChatRouteLayout'
import { StyledAppContainer } from 'components/Layout/LayoutStyle'
import { column } from './columnConfig'
import { useState } from 'react'
import { StyledPanelWrapper } from 'styles/panelStyles.css'
import { useAccounts } from './useAdmin'
import { StyledTabListWrapper } from 'pages/Teams/Teams'

const Pending = () => {
    const { accounts, accounts_loading, total_pages, setPage, filter } = useAccounts({
        active: false,
    })
    return (
        <Table
            columns={column({ pendingTable: true })}
            data={accounts}
            isLoading={accounts_loading}
            page={filter.page}
            totalPages={total_pages}
            setPage={setPage}
        />
    )
}

const AllAccounts = () => {
    const { accounts, accounts_loading, total_pages, setPage, filter } = useAccounts({
        active: true,
    })
    return (
        <Table
            columns={column({ pendingTable: false })}
            data={accounts}
            isLoading={accounts_loading}
            page={filter.page}
            totalPages={total_pages}
            setPage={setPage}
        />
    )
}

const Admin = () => {
    const [activeTab, setActiveTab] = useState(0)
    const handleTabClick = (tabId: number) => {
        setActiveTab(tabId)
    }

    return (
        <StyledAppContainer>
            <StyledContainer>
                <StyledMainWrapper>
                    <StyledChatWrapper>
                        <StyledTabListWrapper>
                            <TabList activeTabId={activeTab} noBorder>
                                <Tab onClick={() => handleTabClick(0)}>Pending</Tab>
                                <Tab onClick={() => handleTabClick(1)}>Verified</Tab>
                            </TabList>
                        </StyledTabListWrapper>

                        <StyledHorizontalDivider />

                        <TabsContext activeTabId={activeTab}>
                            <TabPanels noAnimation>
                                <TabPanel>
                                    <StyledPanelWrapper>
                                        <Pending />
                                    </StyledPanelWrapper>
                                </TabPanel>

                                <TabPanel>
                                    <StyledPanelWrapper>
                                        <AllAccounts />
                                    </StyledPanelWrapper>
                                </TabPanel>
                            </TabPanels>
                        </TabsContext>
                    </StyledChatWrapper>
                </StyledMainWrapper>
            </StyledContainer>
        </StyledAppContainer>
    )
}

export default Admin
